import thLocale from "element-ui/lib/locale/lang/th.js";

const localThLocale = {
    ...thLocale,
    title: "หัวข้อ",
    userQuestion: "เรื่องที่ต้องการสอบถาม",
    transform: "โอนไปยังเจ้าหน้าที่",
    message: "ข้อความ",
    camera: "ถ่ายภาพ",
    file: "เอกสาร",
    evaluate: "การประเมิน",
    eval_title: "การประเมินความพึงพอใจ",
    eval_desc: "ปัญหาได้รับการแก้ไขหรือไม่?",
    eval_submit: "ส่งคำประเมิน",
    msg_title: "กรอกข้อความ",
    msg_submit: "ส่งข้อความ",
    msg_desc: "หากต้องการความช่วยเหลือกรุณาฝากข้อความไว้ เราจะติดต่อกลับโดยเร็วที่สุด",
    sendBtn: "ส่ง",
    tips: "คำแนะนำ",
    sure: "แน่นอน",
    cancel: "ยกเลิก",
    closeTips: "ยกเลิกการสนทนา คุณต้องการดำเนินการต่อหรือไม่?",
    customerInputIng: "ฝ่ายบริการลูกค้ากำลังพิมพ์...",
    historyChat: "ด้านบนเป็นประวัติการสนทนา",
    loading: "กำลังโหลด...",
    noHistory: "ไม่พบประวัติการสนทนาเพิ่มเติม",
    download: "ดาวน์โหลด",
    input: "กรุณากรอกข้อมูล",
    orderStatus: "สถานะธุรกรรม",
    orderNumber: "เลขที่ธุรกรรม",
    showDetail: "ตรวจสอบรายละเอียด",
    orderTime: "เวลา",
    thump: "กดถูกใจ",
    top: "คลิก",
    submit: "ส่ง",
    pleInput: "กรุณากรอก",
    content: "เนื้อหา!",
    rightPhone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง!",
    rightEmail: "กรุณากรอกอีเมลที่ถูกต้อง!",
    emoji: "อิโมจิ",
    leaveMsg: "ฝากข้อความ",
    uploadFile: "อัพโหลดไฟล์",
    reChat: "เริ่มต้นการสนทนาใหม่",
    chatAfterEva: "ประเมินแบบสอบถามหลังจบการสนทนา",
    veryGood: "พอใจมาก ให้ห้าดาว",
    notGood: "ไม่พอใจ ยังต้องปรับปรุง",
    userName: "ชื่อผู้ติดต่อ",
    userPhone: "เบอร์ติดต่อ",
    userEmail: "ที่อยู่อีเมล",
    leaveMsgCon: "เนื้อหาข้อความ",
    submitLeave: "ส่งข้อความ",
    getHistory: "ประวัติการสนทนา",
    isResolved: "ปัญหาได้รับการแก้ไขหรือไม่?",
    leaveTip: "ยังทำได้ไม่ดีพอ ต้องพยายามมากกว่านี้",
    leaveInput: "ทางเรายินดีรับฟังความคิดเห็นเกี่ยวกับการบริการ",
    solved: "แก้ไขแล้ว",
    noSolved: "ยังไม่ได้รับการแก้ไข",
    submitEva: "ส่งคำประเมิน",
    noSubmitEvaEndChat: "ยกเลิกการประเมินสิ้นสุดเซสชัน",
    evaConInput: "กรุณากรอกเนื้อหาการประเมิน!",
    evaLabelSelect: "โปรดประเมินความพึงพอใจ!",
    robotEva1: "ให้คำตอบไม่ถูกต้อง",
    robotEva2: "ไม่เข้าใจ",
    robotEva3: "ตอบคำถามไม่ได้",
    robotEva4: "ไม่สุภาพ",
    customerEva1: "ทัศนคติในการบริการแย่",
    customerEva2: "ไม่ได้รับการตอบกลับ",
    customerEva3: "ไม่ได้รับการแก้ไข",
    customerEva4: "ไม่สุภาพ",
    leaveMessage: "ข้อความต่อไปนี้เป็นข้อความอัตโนมัติ",
    helloMsg: "สวัสดีค่ะ วันนี้ต้องการรับบริการในส่วนไหนดีคะ?",
    noCustomer: "ขออภัย ขณะนี้ไม่มีเจ้าหน้าที่ให้บริการ โปรดติดต่ออีกครั้งภายหลัง",
    isSureLeave: "คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้?",
    customer: "ฝ่ายบริการลูกค้า",
    customerFirst: "V9 ยินดีต้อนรับ! กรุณารอสักครู่  —  กำลังเชื่อมต่อ ",
    connectChat: "เชื่อมต่อการสนทนา",
    busyMessage: "ขออภัย ขณะนี้เจ้าหน้าที่ให้บริการเต็มคู่แชท โปรดรอสักครู่",
    transferFailed: "การเชื่อมต่อล้มเหลว!",
    notWork: "ขออภัย ขณะนี้เจ้าหน้าที่ของเรางดให้บริการ โปรดติดต่ออีกครั้งภายหลัง!",
    closeChat: "จบการสนทนา!",
    newWindow: "เริ่มต้นการสนทนาใหม่!",
    chatOver: "การสนทนาสิ้นสุดแล้ว!",
    backMessage: "ฝ่ายบริการลูกค้ายกเลิกข้อความ!",
    thankMessage: "ขอบคุณสำหรับการประเมิน!",
    fileMax: "ขนาดไฟล์ต้องไม่เกิน 50M!",
    newMessage: "【คุณได้รับข้อความใหม่】",
    inputUserName: "กรุณากรอกชื่อผู้ติดต่อ!",
    inputUserPhone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง!",
    inputUserEmail: "กรุณากรอกอีเมลที่ถูกต้อง!",
    inputLeaveMsg: "กรุณากรอกข้อความ!",
    submitSuc: "ส่งเรียบร้อย!",
    today: "วันนี้",
    fileTypeError : " รูปแบบไฟล์ไม่ถูกต้อง" ,


}
export default localThLocale;



// WEBPACK FOOTER //
// ./src/language/th.js